export default __webpack_public_path__ + "static/media/fedex-inabit.26be5c65.svg";